import axios from "axios";
import Vue from "vue";
import VueCookies from "vue-cookies";
import store from "../store";
const authToken = store?.getters?.getAuth || VueCookies.get("auth");
Vue.use(VueCookies);
axios.defaults.headers.common = {
 "X-Access-Token": authToken
};
export {axios}